<template>
    <div class="inline-block filter-item relative" :class="['align-'+align,hideMenu?'hide-menu':'',type?'type-'+type:'',this.field.isExclude?'is-exclude':'']">
        <div class="main-info tal" :class="[hideMenu?'':'pointer']" @click="handleMenuClick(field)">
            <p class="ellipsis" :title="field.display_name+(showCount?'：'+excludeStr+countText:'')+(showSubtext&&subText?'：'+subText:'')">{{field.display_name}}
                <span v-if="showCount">：
                    <span>{{excludeStr}}</span>
                    <span v-if="!loading">{{count||''}}</span>
                </span>
                <span class="text-color-gray" v-if="showSubtext&&subText">：{{excludeStr}}{{subText||'--'}}</span>
            </p>
            <div class="filter-loading" v-if="loading">
                <div v-loading="loading"></div>
            </div>

            <!--<span v-if="!hideMenu" class="menu-icon" >-->
                 <!--<i class="el-icon-menu"></i>-->
            <!--</span>-->
        </div>
        <div class="close-bar">
            <span class="close-btn" @click.stop="handleRemove(field)">X</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FilterItem",
        props: {
            field: {
                required: true,
                type: Object,
            },
            align: {
                type: String,
                default: 'center',
            },
            showSubtext: {
                type: Boolean,
                default: false,
            },
            showCount: {
                type: Boolean,
                default: false,
            },
            subText:{
                type: String,
            },
            hideMenu: {
                type: Boolean,
                default: false,
            },
            type:{
                type: String,
            },
            loading:{
                type: Boolean,
                default: false,
            }
        },
        computed: {
            count() {
                let config = this.field.config || {};
                let type = config.type;
                if (type == 'content') {
                    let valLength = (this.field.contentValue || []).length
                    return valLength==1?this.countText:valLength;
                } else if (type == 'date') {
                    return (this.field.dateValue || []).join('~');
                } else if(type == 'time'){
                    return (this.field.timeValue || []).join('-');
                } else if (type == 'date_select') {
                    return (this.field.selectLabel||'') + ' ' + (this.field.dateValue || []).join('~');
                } else if (type == 'select') {
                    return this.field.selectLabel;
                }
            },
            countText(){
                let config = this.field.config || {};
                let type = config.type;
                if (type == 'content') {
                    return (this.field.contentValue || []).map(item=>item.name).join(',');
                }else{
                    return this.count;
                }
            },
            excludeStr(){
                let config = this.field.config || {};
                let type = config.type;
                /* 维度不展示包含排除 */
                let isDimension = this.field.dimensionValue;
                if(isDimension) return '';
                if(type=='content'){
                    let isYYTypeStr = this.field.name=='yy_type'?(this.field.selectLabel||''):'';
                    return isYYTypeStr+(this.field.isExclude?'(排除)':'(包含)');
                }
                return '';
            }
        },
        methods: {
            handleMenuClick(field) {
                if(this.hideMenu) return;
                this.$emit('menu', field);
            },
            handleRemove(field) {
                this.$emit('remove', field)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .type-info{
        border: 1px solid #81d3f8!important;
        background-color: #d2effc!important;
    }
    .filter-item {
        padding: 0 24px 0 2px;
        margin: 5px;
        width: 160px;
        border: 1px solid #ffd77a;
        background-color: #fff9e6;
        border-radius: 2px;
        float: left;
        &.hide-menu{
            padding-right: 25px;
        }
        .main-info {
            position: relative;
            padding: 3px 5px;
            min-width: 80px;
            font-size: 12px;
            color: #000;
            p {
                line-height: 16px;
            }

            span.menu-icon {
                position: absolute;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                cursor: pointer;
                top: 50%;
                right: -24px;
                margin-top: -12px;
                font-size: 14px;
            }
        }

        .close-bar {
            position: absolute;
            right: 0;
            top: 0;
            width: 24px;
            height: 100%;
            border-left: solid 1px #dcdee2;
        }

        .close-btn {
            color: #ed4014;
            display: block;
            width: 24px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -12px;
        }


        &.is-exclude.type-info{
            border: 1px solid #ffb08f !important;
            background-color: #ffefe6 !important;
        }
    }

    .align-left {
        text-align: left;
    }

    .align-right {
        text-align: right;
    }

    .align-center {
        text-align: center;
    }

    .filter-loading{
        position: absolute;
        right: 2px;
        top: 2px;
        width: 26px;
        height: 26px;
        z-index: 3;
        transform: scale(0.3);
    }


</style>
